<template>
  <div
    class="relative h-20 min-w-[120px]"
    :class="{ '!h-12': !hasErrors && !small, 'h-8': !hasErrors && small, 'h-16': hasErrors && small}"
  >
    <div class="h-20">
      <div
        v-if="icon"
        class="ml-3 absolute h-12 flex place-items-center place-content-center"
        :class="{'h-8': small }"
      >
        <img
          :src="icon"
          class="h-5 w-5"
        >
      </div>
      <button
        id="dropzone"
        class="ring-1 ring-[#CFCFCF] rounded h-12 px-5 w-full font-source-sans-pro focus:outline-none focus-within:bg-[#e8f0fe] hover:ring-gray group-hover:bg-[#e8f0fe] group-disabled:bg-semigray disabled:bg-semigray
      flex items-center group"
        :class="{ 
          'h-8': small,
          'pl-11': icon
        }"
        type="button"
        @click="show()"
      >
        <span
          v-if="clock.hour !== -1 && clock.minute !== -1"
        >{{ clock.hour | niceFormat }}:{{ clock.minute | niceFormat }}</span>
        <p
          v-else 
          class="text-semigray whitespace-nowrap"
        >
          {{ placeholder }}
        </p>
        <img
          src="/img/icons/inputs/dropdown_arrow_icon.svg"
          class="h-[16px] w-[16px] ml-6 transform transition-all group-hover:text-gray-darkest duration-500 ml-auto"
          :class="{ 
            'rotate-180': hasFocus
          }"
        >
      </button>
      <div
        :class="{ 
          'ring-[#CFCFCF] max-h-[224px] px-5 py-3': hasFocus,
          'ring-transparent max-h-[0px] py-0 px-5': !hasFocus,
        }"
        class="z-50 absolute top-14 ring-1 bg-white rounded font-source-sans-pro h-auto transition-height duration-500 overflow-y-auto w-full "
      >
        <div class="flex flex-col place-content-around place-items-center">
          <div class="flex flex-row gap-6">
            <div class="w-auto flex flex-col place-items-center ">
              <i
                class="fas fa-chevron-up hover:text-red cursor-pointer text-2xl"
                @click="addHour(1)"
              />
              <small class="text-base">óra</small>
              <input
                ref="searchfilter"
                v-model="clock.hour"
                type="text"
                class="text-center w-12 text-base"
                placeholder="óra"
                maxlength="2"
                @change="update()"
              >
              <i
                class="fas fa-chevron-down hover:text-red cursor-pointer text-2xl"
                @click="addHour(-1)"
              />
            </div>
            <div class="w-auto flex flex-col place-items-center">
              <i
                class="fas fa-chevron-up hover:text-red cursor-pointer text-2xl"
                @click="addMinute(1)"
              />
              <small class="text-base">perc</small>
              <input
                v-model="clock.minute"
                type="text"
                class="text-center w-12 text-base"
                placeholder="perc"
                maxlength="2"
                @change="update()"
              >
              <i
                class="fas fa-chevron-down hover:text-red cursor-pointer text-2xl"
                @click="addMinute(-1)"
              />
            </div>
          </div>
          <div class="w-full text-center mt-3">
            <a
              class="link link-red"
              @click="remove()"
            >Törlés</a>
          </div>
        </div>
      </div>
      <div
        v-if="hasErrors"
        :class="{ '!h-[32px]': validationErrors }"
        class="font-source-sans-pro text-sm text-red transition-all h-[0px] duration-1000"
      >
        {{ validationErrors ? validationErrors[0] : "" }}
      </div>
    </div>
  </div>
</template>

<script>
/* hh:mm:ss */
export default {
  filters: {
    niceFormat(e) {
      if (e !== -1) {
        return e < 10 ? "0" + e : e;
      } else {
        return "";
      }
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    hasErrors: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    validationErrors: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      hasFocus: false,
      clock: {
        hour: -1,
        minute: -1,
        second: "00"
      }
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue === null) {
        this.clock.hour = -1;
        this.clock.minute = -1;
      } else {
        const time = this.$moment(newValue, "HH:mm:ss");
        this.clock.hour = time.hour();
        this.clock.minute = time.minute();
      }
      this.update();
    }
  },
  beforeMount() {
    if (process.browser) {
      window.addEventListener("click", this.close);
    }
  },
  mounted() {
    if (this.value === null) {
      this.clock.hour = -1;
      this.clock.minute = -1;
    } else {
      const time = this.$moment(this.value, "HH:mm:ss");
      this.clock.hour = time.hour();
      this.clock.minute = time.minute();
    }
    this.update();
  },
  beforeDestroy() {
    if (process.browser) {
      window.removeEventListener("click", this.close);
    }
  },
  methods: {
    addHour(val) {
      if (this.clock.hour === 0 && val === -1) {
        this.clock.hour = 23;
      } else if (this.clock.hour === 23 && val === 1) {
        this.clock.hour = 0;
      } else {
        this.clock.hour = this.clock.hour + val;
      }
      this.update();
    },
    addMinute(val) {
      if (this.clock.minute === 0 && val === -1) {
        this.clock.minute = 59;
        this.addHour(-1)
      } else if (this.clock.minute === 59 && val === 1) {
        this.clock.minute = 0;
        this.addHour(1)
      } else {
        this.clock.minute = this.clock.minute + val;
      }
      this.update();
    },
    update() {
      if (this.clock.hour !== -1) {
        if (this.clock.hour === 24) {
          this.clock.hour = 0;
        }
        const output =
          (this.clock.hour < 10 ? "0" + this.clock.hour : this.clock.hour) +
          ":" +
          (this.clock.minute < 10
            ? "0" + this.clock.minute
            : this.clock.minute) +
          ":" 
          +
          this.clock.second;
        this.$emit("input", output);
      } else {
        this.$emit("input", null);
      }
    },
    remove() {
      this.clock.hour = -1;
      this.clock.minute = -1;
      this.update();
      this.hasFocus = false;
    },
    show() {
      this.hasFocus = !this.hasFocus;
      if (this.clock.hour === -1) {
        this.clock = {
          hour: 16,
          minute: 0,
          second: "00"
        };
      }
      this.update();
      // this.$nextTick(() => {
      //   //egyelőre kivéve, lehet majd később betesszük
      //   //this.$refs.searchfilter.focus();
      // });
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.hasFocus = false;
      }
    }
  }
};
</script>
